export default __webpack_public_path__ + "static/media/project-4.1.7bae19ee.png";